import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  masraflariListele,
  masrafOlustur,
  masrafGuncelle,
  masrafSil,
  karlilikOzeti,
  karlilikTrendi,
  type KarlilikSorgusu,
  type MasrafGuncelleIstegi,
  type MasrafOlusturIstegi,
  type MasrafSorgusu,
} from '@emanetx/sdk';
import { istemci } from '../istemci.js';

const MASRAF_QK = (sorgu: MasrafSorgusu) => ['masraflar', sorgu] as const;

export function useMasraflar(sorgu: MasrafSorgusu) {
  return useQuery({
    queryKey: MASRAF_QK(sorgu),
    queryFn: () => masraflariListele(istemci, sorgu),
    placeholderData: (o) => o,
  });
}

export function useMasrafOlustur() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (giris: MasrafOlusturIstegi) => masrafOlustur(istemci, giris),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['masraflar'] }),
  });
}

export function useMasrafGuncelle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, giris }: { id: string; giris: MasrafGuncelleIstegi }) =>
      masrafGuncelle(istemci, id, giris),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['masraflar'] }),
  });
}

export function useMasrafSil() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => masrafSil(istemci, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['masraflar'] }),
  });
}

export function useKarlilik(sorgu: KarlilikSorgusu) {
  return useQuery({
    queryKey: ['karlilik', sorgu],
    queryFn: () => karlilikOzeti(istemci, sorgu),
    placeholderData: (o) => o,
  });
}

export function useKarlilikTrendi(sorgu: KarlilikSorgusu) {
  return useQuery({
    queryKey: ['karlilik-trend', sorgu],
    queryFn: () => karlilikTrendi(istemci, sorgu),
    placeholderData: (o) => o,
  });
}
